import React, { useState, Component } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams,
} from "react-router-dom";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import About from "./About";
import Works from "./Works";
import Home from "./Home";
import Contact from "./Contact";

import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 1100px;
  max-width: 90%;
  margin: auto;
  min-height: 80vh;
  height: auto;
  justify-content: center;
  align-items: center;
`;

export function Template({ onSwitch }) {
  return (
    <div>
      <Router basename={process.env.PUBLIC_URL}>
        <Header onSwitch={onSwitch} />
        <Switch>
          <Route path="/about">
            <Container>
              <About />
            </Container>
          </Route>
          <Route path="/works">
            <Container>
              <Works />
            </Container>
          </Route>
          <Route path="/contact">
            <Container>
              <Contact />
            </Container>
          </Route>
          <Route path="/">
            <Container>
              <Home />
            </Container>
          </Route>
        </Switch>
      </Router>
      <Footer />
    </div>
  );
}

export default Template;
